var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"pa-3",attrs:{"color":("grey " + (_vm.theme.isDark ? 'darken-2' : 'lighten-4'))}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"max-width":"600","type":"card"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }